"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var DEFAULT_PROPS = {
  resourceType: 'EditorialCards_1_0_0',
  editorialLayout: 'extralarge',
  columns: []
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;